import React from "react";
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
export const ThemeProvider = (props) => {
    return (React.createElement(EmotionThemeProvider, { theme: props.theme }, props.children));
};
//# sourceMappingURL=ThemeProvider.js.map